"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("vsplit", styles.root, className),
        splitter: styling_1.mergeStyles("vsplit-splitter", styles.splitter),
        splitterHandle: styling_1.mergeStyles("vsplit-splitter-content", styles.splitterHandle),
        topPane: styling_1.mergeStyles("vsplit-top-pane", styles.topPane),
        topContent: styling_1.mergeStyles("vsplit-top-content", styles.topContent),
        bottomPane: styling_1.mergeStyles("vsplit-bottom-pane", styles.bottomPane),
        bottomContent: styling_1.mergeStyles("vsplit-bottom-content", styles.bottomContent)
    };
});
exports.getClassNames = getClassNames;
